export default __webpack_public_path__ + "static/logo-4-ac155266b1d027df5ca225a67d822012.png";